import { CommonMessage } from '@frontend/lang';
import { User } from '@frontend/user/utils';
import React from 'react';
import { LuLanguages, LuSettings } from 'react-icons/lu';

import AccountMembership from './account-membership/account-membership.component';
import GlobalSearch from './global-search/global-search.component';
import useHeader from './header-controller';
import LanguageSelectModal from './language-select-modal/language-select-modal.component';

export interface Props {
    className?: string;
}

export const Header = (props: Props) => {
    const { className, ...rest } = props;
    const viewProps = useHeader(rest);

    return (
        <div className={'top-0 ' + (className ?? '')}>
            <header
                className='bg-background-surface border-border-default sticky top-0 z-50 flex h-18 w-full items-center gap-4 border-b'
                id='main-admin-header'>
                <div className='mx-6 flex items-center'>
                    <GlobalSearch />
                </div>
                <div className='flex h-full w-full items-center justify-end'>
                    <div className='inline-flex items-center justify-end gap-2 px-5'>
                        <ActionButton
                            id='admin-button'
                            icon={<LuSettings className='size-5 w-full' />}
                            onClick={() => viewProps.navigate('/')}
                        />
                        <ActionButton
                            id='language-button'
                            icon={<LuLanguages className='size-5 w-full' />}
                            onClick={() => viewProps.setShowLanguageSelect(true)}
                        />
                    </div>
                    <a
                        data-testid='profile-link'
                        className='border-border-default hover:bg-brand-light flex h-full cursor-pointer items-center gap-3 border-l px-5'
                        href='/profile'
                        onClick={(e) => {
                            e.preventDefault();
                            viewProps.navigate('/profile');
                        }}>
                        {viewProps.user && (
                            <div className='bg-brand-primary text-background-surface flex size-10 items-center justify-center rounded-full text-lg font-medium'>
                                {new User(viewProps.user).getInitials()}
                            </div>
                        )}
                        <div className='flex flex-col'>
                            <span className='text-foreground-default text-base font-semibold'>
                                {viewProps.user ? new User(viewProps.user).getDisplayName() : CommonMessage.OBJECTS.USER.DEFAULT}
                            </span>
                            <span className='text-brand-muted text-xs font-medium'>{viewProps.user?.unique_identifier}</span>
                        </div>
                    </a>

                    <AccountMembership buttonStyle='border-border-default text-brand-muted flex items-center h-full border-l px-5 cursor-pointer uppercase font-extrabold hover:bg-brand-light' />
                </div>
            </header>
            {viewProps.showLanguageSelect && <LanguageSelectModal onClose={() => viewProps.setShowLanguageSelect(false)} />}
        </div>
    );
};
export default Header;

interface ActionButtonProps {
    icon: React.ReactNode;
    hidden?: boolean;
    onClick?: () => void;
    id?: string;
}

const ActionButton = (props: ActionButtonProps) => {
    if (props.hidden) {
        return <></>;
    }
    return (
        <div
            data-testid={props.id}
            onClick={() => props.onClick && props.onClick()}
            data-variant='Default'
            className='bg-background-default text-foreground-default hover:bg-brand-light flex size-9 items-center justify-between rounded-lg hover:cursor-pointer'>
            {props.icon}
        </div>
    );
};
